<template>
  <div id="foot">
    <div class="w-width">
      <div class="tail">
        <div class="about">
          <div class="title"> 关于我们 </div>
          <ul>
            <li><a href="http://www.cqvip.com/"
                 target="_blank">维普网</a></li>
            <li><a href="http://www.ktnw.cn/"
                 target="_blank">课堂内外</a></li>
            <li><a href="javascript:;"
                 @click="serveVisible=true">服务协议</a></li>
            <li><a href="javascript:;"
                 @click="$refs['enter-protocol'].open()">入驻协议</a></li>
            <li><a href="javascript:;"
                 @click="concealVisible=true">隐私政策</a></li>
          </ul>
        </div>
        <div class="link">
          <div class="title"> 友情链接 </div>
          <ul>
            <li><a href="http://www.moe.gov.cn/"
                 target="_blank">中华人民共和国教育部</a></li>
            <li><a href="http://www.nies.edu.cn/"
                 target="_blank">中国教育科学研究院</a></li>
            <li><a href="https://www.cast.org.cn/"
                 target="_blank">中国科学技术协会</a></li>
            <li><a href="http://www.cqast.cn/"
                 target="_blank">重庆市科学技术协会</a></li>
            <li><a href="http://www.cqkepu.com/"
                 target="_blank">重庆科普集团</a></li>
            <li><a href="https://www.nppa.gov.cn/"
                 target="_blank">国家新闻出版署</a></li>
            <li><a href="http://qikan.cqvip.com/">中文期刊服务平台</a></li>
            <li><a href="https://vpcs.fanyu.com/">维普论文检测系统</a></li>
            <li><a href="https://datauthor.com/">学术期刊投稿分析系统</a></li>
          </ul>
        </div>
        <div class="contact">
          <div class="title">联系我们</div>
          <p>地址：中国·重庆两江新区</p>
          <p>邮编：400000</p>
          <p>电话：023-63658989（业务支持）</p>
        </div>
        <div class="focus">
          <div class="title">关注我们</div>
          <ul>
            <li> <img src="~@/assets/images/codetest02.png"
                   alt=""> <span>维普资讯</span> </li>
            <li> <img src="~@/assets/images/codetest01.png"
                   alt=""> <span>课堂内外</span> </li>
          </ul>
        </div>
      </div>
      <div class="content">
        <p>
          <span>版权所有©维普资讯</span>
          <span>ICP备案号：<a href="https://beian.miit.gov.cn/"
               target="_blank">渝B2-20050021-1</a></span><span>互联网出版许可证 新出网证(渝)字10号</span>
          <span>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50019002500403&amp;from=index"
               target="_blank"><img src="@/assets/images/beian.png" />渝公网安备 50019002500403号</a></span>
          <span>举报邮箱：jubao@cqvip.com</span>
          <span>建议浏览器使用Edge、firefox、谷歌浏览器</span>
        </p>
      </div>
    </div>
    <el-dialog :visible.sync="serveVisible"
               width="1000px"
               :append-to-body="true">
      <div slot="title">服务协议</div>
      <div class="mineBox">
        <el-scrollbar style="height:100%">
          <h6>露禾平台用户协议</h6>
          <p class="rtime">更新日期：2024年5月22日</p>
          <p class="rtime">生效日期：2024年5月22日</p>
          <h5>导言</h5>
          <p class="indent2">欢迎您使用露禾平台产品及相关服务！本服务协议双方为重庆维普朗润数据科技有限公司（以下简称“公司”）与维普朗润用户，本服务协议具有合同效力。</p>
          <p class="indent2">“露禾平台”产品及相关服务，<strong>系指公司通过合法拥有并运营的、标注名称为“露禾平台”（luhe.cqvip.com）的网站以及“露禾”的APP客户端向您提供的产品与服务，包括但不限于搜索查询、下载全文、个性化推荐、发布信息等核心功能以及其他功能，为教研服务与创作的平台。</strong>《露禾平台用户协议》（以下简称“本协议”）是您与公司之间就您注册、登录、使用（以下统称“使用”）“露禾平台”产品及相关服务所订立的协议。</p>
          <p class="indent2">为了更好地为您提供服务，请您在开始使用“露禾平台”产品及相关服务之前，认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通和使用特殊单项服务的条款、法律适用和争议解决条款等。<strong>其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。如您不同意本协议，这将导致我们无法为您提供完整的产品和服务，您也可以选择停止使用。如您自主选择同意或使用“露禾平台”产品及相关服务，则视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与“露禾平台”产品及相关服务相关的协议和规则（包括但不限于《隐私政策》）的约束。</strong></p>
          <h5>第一章 露禾平台产品及相关服务</h5>
          <p>1.1 为更好的提升用户体验及服务，公司将不定期提供“露禾平台”产品及相关服务的更新或改变（包括但不限于产品修改、升级、功能强化、开发新服务、产品替换等）。<strong>为保证“露禾平台”产品及相关服务安全、提升用户服务，在“露禾平台”产品及相关服务的部分或全部更新后，公司将在可行的情况下以妥当的方式（包括但不限于系统提示、公告、站内信等）提示您，您有权选择接受更新后的版本；如您选择不作更新，“露禾平台”产品及相关服务的部分功能将受到限制或不能正常使用。</strong></p>
          <p>1.2 除非得到公司事先书面授权，您不得以任何形式对“露禾平台”产品及相关服务进行包括但不限于改编、复制、传播、垂直搜索、镜像或交易等未经授权的访问或使用。</p>
          <p>1.3 <strong>您无需注册也可开始使用“露禾平台”产品及相关服务，但部分功能或服务可能会受到影响。</strong>同时，您也理解，为使您更好地使用“露禾平台”产品及相关服务，保障您的账号安全，某些功能和/或某些单项服务项目（下载获取文章、认领作品）将要求您按照国家相关法律法规的规定，提供真实的身份信息实名注册并登录后方可使用。</p>
          <h5>第二章 关于“账号”</h5>
          <p>2.1 <strong>“露禾平台”产品及相关服务为您提供了注册通道，您有权选择合法且符合站点要求的字符组合作为自己的账号，并自行设置符合安全要求的密码。用户设置的账号、密码是用户用以登录并使用“露禾平台”产品及相关服务的凭证。</strong></p>
          <p>2.2 您理解并承诺，您所设置的账号不得违反国家法律法规及公司的相关规则，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为，您的账号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等足以让人引起混淆的方式）开设账号，不得恶意注册“露禾平台”账号（包括但不限于频繁注册、批量注册账号等行为）。公司有权对您提交的信息进行审核。</p>
          <p>2.3 <strong>您的账号仅限于您本人使用，未经公司书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。</strong>如果公司发现或者有合理理由认为使用者并非账号初始注册人，为保障账号安全，公司有权立即暂停或终止向该注册账号提供服务，或注销该账号。</p>
          <p>2.4 <strong>您有责任维护个人账号、密码的安全性与保密性，并对您以注册账号名义所从事的活动承担全部法律责任，包括但不限于您在“露禾平台”产品及相关服务上进行的任何数据修改、言论发表、款项支付等操作行为可能引起的一切法律责任。</strong>您应高度重视对账号与密码的保密，在任何情况下不向他人透露账号及密码。若发现他人未经许可使用您的账号或发生其他任何安全漏洞问题时，您应当立即通知公司。</p>
          <p>2.5 <strong>在丢失账号或遗忘密码时，您可遵照公司的申诉途径及时申诉请求找回账号或密码。您理解并认可，公司的密码找回机制仅需申诉流程上所填资料与系统记录资料具有一致性，而无法识别申诉人是否系真正账号有权使用者。</strong>公司特别提醒您应妥善保管您的账号和密码。当您使用完毕后，应安全退出。如因您保管不当等自身原因或其他不可抗因素导致遭受盗号或密码丢失，您将自行承担相应责任。</p>
          <p>2.6 <strong>在注册、使用和管理账号时，您应保证注册账号时填写的身份信息的真实性，请您在注册、管理账号时使用真实、准确、合法、有效的相关身份证明材料及必要信息（包括您的姓名及电子邮件地址、联系电话）。</strong>依照国家相关法律法规的规定，为使用“露禾平台”产品及相关服务的部分功能，您需要填写真实的身份信息，请您按照相关法律规定完成实名认证，并注意及时更新上述相关信息。若您提交的材料或提供的信息不规范或不符合要求的，则公司有权拒绝为您提供相关功能，您可能无法使用“露禾平台”产品及相关服务或在使用过程中部分功能受到限制。</p>
          <p>2.7 <strong>除自行注册“露禾平台”账号外，用户也可授权使用其合法拥有的包括但不限于中小学学校或其关联学校用户账号，以及实名注册的第三方产品用户账号登录使用“露禾平台”产品及相关服务，但第三方产品或平台对此有限制或禁止的除外。</strong>当用户以前述已有账号登录使用的，应保证相应账号已进行实名注册登记，并同样适用本协议中的相关条款。</p>
          <P>2.8 <strong>您理解并同意，除您登录、使用“露禾平台”产品及相关服务外，您还可以用“露禾平台”账号登录使用公司及其关联公司提供的其他产品、服务。</strong>您以“露禾平台”账号登录并使用前述服务时，将受到前述服务的实际提供方的《用户协议》及其他协议条款约束。</P>
          <h5>第三章 用户个人信息保护</h5>
          <p>公司与您一同致力于您个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，保护用户个人信息是公司的基本原则之一。在使用“露禾平台”产品及相关服务的过程中，您可能需要提供您的个人信息（包括但不限于姓名、电话号码、邮箱等），以便公司向您提供更好的服务和相应的技术支持。公司将运用加密技术、匿名化处理等其他与“露禾平台”产品及相关服务相匹配的技术措施及其他安全措施保护您的个人信息，更多关于用户个人信息保护的内容，<a href="javascript:;"
               @click="showyins()">请参见《隐私政策》</a>。</p>
          <h5>第四章 用户行为规范</h5>
          <p>4.1 用户行为要求</p>
          <p>您应当对您使用本产品及相关服务的行为负责，除非法律允许或者经公司事先书面许可，您使用“露禾平台”产品及相关服务不得具有下列行为：</p>
          <p>4.1.1 <strong>使用未经公司授权或许可的任何插件、外挂、系统或第三方工具对“露禾平台”产品及相关服务的正常运行进行干扰、破坏、修改或施加其他影响。</strong></p>
          <p>4.1.2 利用或针对“露禾平台”产品及相关服务进行任何危害计算机网络安全的行为，包括但不限于：</p>
          <p><strong>（1）非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的活动；</strong></p>
          <p><strong>（2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；</strong></p>
          <p><strong>（3）明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；</strong></p>
          <p><strong>（4）使用未经许可的数据或进入未经许可的服务器/账号；</strong></p>
          <p><strong>（5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；</strong></p>
          <p><strong>（6）未经许可，企图探查、扫描、测试“露禾平台”系统或网络的弱点或其它实施破坏网络安全的行为；</strong></p>
          <p><strong>（7）企图干涉、破坏“露禾平台”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；</strong></p>
          <p><strong>（8）伪造TCP/IP数据包名称或部分名称；</strong></p>
          <p><strong>（9） 对“露禾平台”产品及相关服务进行反向工程、反向汇编、编译或者以其他方式尝试发现本产品的源代码；</strong></p>
          <p><strong>（10）恶意注册“露禾平台”产品及相关服务的账号，包括但不限于频繁、批量注册账号；</strong></p>
          <p><strong>（11）违反法律法规、本协议、公司的相关规则及侵犯他人合法权益的其他行为。</strong></p>
          <p>4.2 如果公司有理由认为您的行为违反或可能违反上述约定的，公司可独立进行判断并处理，且有权在不事先通知的情况下终止向您提供服务，并追究相关法律责任。</p>
          <h5>第五章 露禾平台信息内容的使用规范</h5>
          <p>5.1 未经公司书面许可，您不得自行或授权、允许、协助任何第三人对本协议“露禾平台”产品及相关服务中信息内容进行如下行为：</p>
          <p>（1）复制、读取、采用“露禾平台”产品及相关服务的信息内容，用于包括但不限于宣传、增加阅读量、浏览量等商业用途；</p>
          <p>（2）擅自编辑、整理、编排“露禾平台”产品及相关服务的信息内容后在“露禾平台”产品及相关服务的源页面以外的渠道进行展示；</p>
          <p>（3）采用包括但不限于特殊标识、特殊代码等任何形式的识别方法，自行或协助第三人对“露禾平台”产品及相关服务的信息内容产生流量、阅读量引导、转移、劫持等不利影响；</p>
          <p>（4）其他非法获取或使用“露禾平台”产品及相关服务的信息内容的行为。</p>
          <p>5.2 经公司书面许可后，您对“露禾平台”产品及相关服务的信息内容的分享、转发等行为，还应符合以下规范：</p>
          <p>（1）<strong>对抓取、统计、获得的相关搜索热词、命中率、分类、搜索量、点击率、阅读量等相关数据，未经公司事先书面同意，不得将上述数据以任何方式公示、提供、泄露给任何第三人；</strong></p>
          <p>（2）<strong>不得对“露禾平台”产品及相关服务的源网页进行任何形式的任何改动，包括但不限于“露禾平台”产品及相关服务的首页链接，广告系统链接等入口，也不得对“露禾平台”产品及相关服务的源页面的展示进行任何形式的遮挡、插入、弹窗等妨碍；</strong></p>
          <p>（3）<strong>应当采取安全、有效、严密的措施，防止“露禾平台”产品及相关服务的信息内容被第三方通过包括但不限于“蜘蛛（spider）”程序等任何形式进行非法获取；</strong></p>
          <p>（4）<strong>不得把相关数据内容用于公司书面许可范围之外的目的，进行任何形式的销售和商业使用，或向第三方泄露、提供或允许第三方为任何方式的使用；</strong></p>
          <p>（5）向任何第三人分享、转发、复制“露禾平台”产品及相关服务信息内容的行为，应当遵守公司为此制定的其他规范和标准。</p>
          <h5>第六章 服务/广告的变更、使用</h5>
          <p>6.1 您理解并同意，公司提供的“露禾平台”产品及相关服务是按照现有技术和条件所能达到的现状提供的。公司会尽最大努力向您提供服务，确保服务的连贯性和安全性。<strong>您理解，公司不能随时预见和防范技术以及其他风险，包括但不限于不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用本产品及服务以及其他的损失和风险。</strong></p>
          <p>6.2 <strong>您理解并同意，公司为了服务整体运营、平台运营安全的需要，有权视具体情况有权决定服务/功能设置、范围，修改、中断、中止或终止“露禾平台”产品及相关服务。</strong></p>
          <p>6.3 广告</p>
          <p>6.3.1 <strong>您理解并同意，在使用“露禾平台”产品及相关服务过程中公司可能会向您推送具有相关性的信息、广告发布或品牌推广服务，且公司将在“露禾平台”产品及相关服务中展示“露禾平台”产品及相关服务相关和/或第三方供应商、合作伙伴的商业广告、推广或信息（包括商业或非商业信息）。</strong></p>
          <p>6.3.2 <strong>在使用“露禾平台”时，公司可能会基于偏好、兴趣等方面向您推送程序化广告，您可以在“露禾平台”设置中关闭程序化广告的推送，如果关闭，您看到的广告数量将保持不变，但广告的相关性会降低。您可以退订我们发送给您的营销短信。</strong></p>
          <p>6.3.3 公司依照法律规定履行广告及推广相关义务，您应当自行判断该广告或推广信息的真实性和可靠性并为自己的判断行为负责。除法律法规明确规定外，您因该广告或推广信息进行的购买、交易或因前述内容遭受的损害或损失由您自行承担，公司不予承担责任。</p>
          <h5>第七章 知识产权</h5>
          <p>7.1 公司在“露禾平台”产品及相关服务中提供的内容（包括但不限于产品、技术、程序、网页、文字、图片、图像、图表、版面设计、电子文档等）的知识产权属于公司所有。公司提供本服务时所依托的产品的著作权、专利权及其他知识产权均归公司所有。未经公司许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载）“露禾平台”产品及相关服务中的内容。</p>
          <p>7.2 <strong>您确认并同意授权公司以公司自己的名义或委托专业第三方对侵犯您上传发布的享有知识产权的内容进行代维权，维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等，公司有权对维权事宜做出决策并独立实施。</strong></p>
          <p>7.3 公司为“露禾平台”开发、运营提供技术支持，并对“露禾平台”产品及相关服务的开发和运营等过程中产生的所有数据和信息等享有法律法规允许范围内的全部权利。</p>
          <p>7.4 <strong>请您在任何情况下都不要私自使用公司的包括但不限于“露禾平台”和“luhe.cqvip.com”等在内的任何商标、服务标记、商号、域名、网站名称或其他显著品牌特征等（以下统称为“标识”）。</strong>未经公司事先书面同意，您不得将本条款前述标识以单独或结合任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理该些标识的行为。由于您违反本协议使用公司上述商标、标识等给公司或他人造成损失的，由您承担全部法律责任。</p>
          <h5>第八章 免责声明</h5>
          <p>8.1 您理解并同意，“露禾平台”产品及相关服务可能会受多种因素的影响或干扰，公司不保证(包括但不限于)：</p>
          <p>8.1.1 <strong>“露禾平台”产品及相关服务完全适合用户的所有使用要求；</strong></p>
          <p>8.1.2 <strong>“露禾平台”产品及相关服务不受干扰，及时、安全、可靠或不出现任何错误；您经由公司取得的任何产品、服务或其他材料符合用户的期望；</strong></p>
          <p>8.1.3 <strong>“露禾平台”产品及相关服务中任何错误都将能得到更正。</strong></p>
          <p>8.2 您理解并同意，在使用“露禾平台”产品及相关服务过程中，可能遇到不可抗力等因素（不可抗力是指不能预见、不能克服并不能避免的客观事件），包括但不限于自然灾害(如洪水、地震、台风等)、政府行为、战争、罢工、骚动、暴乱等。出现不可抗力情况时，公司将努力在第一时间及时修复，但因不可抗力造成的损失，公司在法律法规范围内免于承担责任。</p>
          <p>8.3 <strong>公司依据本协议约定获得处理违法违规内容的权利，该权利不构成公司的义务或承诺，公司不能保证及时发现违法行为或进行相应处理。</strong></p>
          <p>8.4 <strong>您理解并同意，关于“露禾平台”产品及相关服务，公司不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对“露禾平台”产品及相关服务的使用行为需自行承担相应风险。</strong></p>
          <p>8.5 您理解并同意，本协议是在保障遵守国家法律法规、维护公序良俗，保护他人合法权益，公司在能力范围内尽最大的努力按照相关法律法规进行判断，但并不保证公司判断完全与司法机关、行政机关的判断一致，如因此产生的后果您已经理解并同意自行承担。</p>
        </el-scrollbar>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="concealVisible"
               width="1000px"
               :append-to-body="true">
      <div slot="title">隐私政策</div>
      <div class="mineBox">
        <el-scrollbar style="height:100%">
          <h6>露禾平台隐私政策</h6>
          <p class="rtime">更新日期：2024年5月22日</p>
          <p class="rtime">生效日期：2024年5月22日</p>
          <h5>引言</h5>
          <p class="indent2">欢迎您使用露禾平台（luhe.cqvip.com），露禾平台是由重庆维普朗润数据科技有限公司（以下简称“朗润”）与重庆课堂内外杂志社出版有限公司（以下简称“课堂内外”）协同开发并管理，露禾平台对每一位用户的隐私权采取高度尊重且保护的态度。朗润与课堂内外非常重视用户的个人信息和隐私保护，为同时给您提供更准确、有个性化的服务和更安全的互联网环境，我们依据《中华人民共和国网络安全法》、《信息安全技术 个人信息安全规范》（GB/T 35273-2020）以及其他相关法律法规和技术规范，将 《隐私政策》相关内容进行了更新，进一步明确了收集/使用/对外提供的原则，进一步阐述了关于您个人信息的相关权利等。</p>
          <p class="indent2">您在使用露禾平台的产品或服务时，露禾平台可能会收集和使用您的相关信息。为此，希望通过本《隐私政策》向您说明，露禾平台如何取得、使用、分享、保存和管理这些信息。<strong>请在使用我们的各项产品与服务前，仔细阅读并充分理解本政策（尤其是加粗提示的内容），并在需要时，按照本政策的指引，做出适当的选择。如果您不同意本政策的内容，将可能导致我们的产品或服务无法正常运行，无法达到最优的服务效果，您应立即停止访问/使用我们的产品或服务。您继续使用我们提供的产品或服务的行为，则表示您充分理解并同意本《隐私政策》（包括更新版本）的全部内容。</strong></p>
          <p>本《隐私政策》将帮助您了解以下内容：</p>
          <p><strong>第一章 如何收集您的个人信息</strong></p>
          <p><strong>第二章 如何使用您的个人信息</strong></p>
          <p><strong>第三章 如何共享、转让、公开披露您的个人信息</strong></p>
          <p><strong>第四章 如何保护您的个人信息</strong></p>
          <p><strong>第五章 如何保存您的个人信息</strong></p>
          <p><strong>第六章 关于cookies的使用</strong></p>
          <p><strong>第七章 管理、查看或删除您的个人信息</strong></p>
          <p><strong>第八章 本政策如何更新</strong></p>
          <p><strong>第九章 投诉及建议</strong></p>
          <h5>第一章 如何收集您的个人信息</h5>
          <h5>1.1 您向露禾平台提供相关个人信息</h5>
          <p class="indent2">1.1.1 为使用露禾平台的产品或服务，<strong>建议您首先注册账号并登录；</strong></p>
          <p class="indent2">1.1.2 <strong>如果您选择手机登录方式，您需向我们提供您的手机号码。我们收集这一信息是为了识别和验证您的身份。</strong>这也有助于露禾平台将您的手机号码与露禾平台账号绑定，以此实现该账号项下的数据在不同设备之间的同步；</p>
          <p class="indent2">1.1.3 在注册完成后，<strong>您还可以选择修改或补充您的昵称、手机号、邮箱、学科信息（不提供这些信息不影响您使用露禾平台的产品或服务），这些信息均属于您的账号信息。</strong>对于该等账号信息所涉的个人信息，露禾平台将按照本《隐私政策》予以保护；</p>
          <p class="indent2">1.1.4 您购买露禾平台提供的收费产品或服务时，您可能需要向露禾平台提供您的账号信息、手机号。为了帮助您顺利完成交易、保障您的交易安全、查询订单信息等，在您下单交易时，我们会<strong>收集您的交易商品/服务信息、交易时间、订单号、交易金额、支付方式、联系电话、第三方支付信息；</strong></p>
          <p class="indent2">1.1.5 在您使用露禾平台产品或服务时，您可能会因账号管理、产品使用等问题联系露禾平台客服。为此，您可能<strong>需要向露禾平台提供姓名、手机号码、充值记录、购买记录、支付记录、系统操作记录、第三方支付方式（支付宝支付、微信支付）</strong>，便于露禾平台的客服人员与您联系，并帮助您解决相关问题。如果您拒绝提供相关信息，露禾平台可能无法帮助您解决相关问题。</p>

          <h5>1.2 露禾平台通过调用设备权限收集您的相关个人信息</h5>
          <p class="indent2">1.2.1 为提升露禾平台产品或服务的使用体验和便利程度，露禾平台可能会通过调用设备权限的方式收集您的如下个人信息。<strong>如果您不同意提供这些个人信息，您可能无法使用与提升用户体验相关的功能；</strong></p>
          <p class="indent2">1.2.2 若您希望通过移动网络或移动运营商信息使自己账号与机构关联，免费获取机构文献下载权限。<strong>您需要通过PC设备连接该机构局域网络，并使终端处于该网络环境内进行机构权限绑定；</strong></p>
          <p class="indent2">1.2.3 若您同意向露禾平台下载、上传您的文献资料，您<strong>需选择授权露禾平台调用您所使用设备的存储权限；</strong></p>
          <p class="indent2">1.2.4 为学术研究、应用研究的需要，露禾平台可能采集您提供的<strong>姓名、性别、身份证号、实人信息、学历、专业、研究领域</strong>，以完成学术期刊中个人作品的认领和认证，但露禾平台承诺此类信息不对外第三方提供；</p>
          <p class="indent2">1.2.5 为向您推荐合适的产品或服务和履行双方间签订的协议，露禾平台将<strong>采集您的个人检索、浏览记录，包括：您在露禾平台产品及/或服务浏览记录、检索记录、点击记录、学习数据，以便于您重复检索和浏览相关文献。</strong></p>
          <h5>1.3 第三方向您收集的信息</h5>
          <p class="indent2">1.3.1 第三方付款服务提供商收集相关个人信息</p>
          <p class="indent2">您可以通过向露禾平台付款的方式获取露禾平台相关的产品及虚拟产品。上述付款服务可能由露禾平台以外的第三方提供，露禾平台并不会获取与您付款相关的密码等信息。但可能从第三方支付平台获得您的第三方支付信息（支付宝支付、微信支付）。若您希望了解第三方服务提供商收集个人信息的具体规则，请查阅您选择的第三方付款服务提供商的隐私政策。</p>
          <p class="indent2"><strong>1.4 您充分知晓，在以下情形下，我们收集、使用个人信息无需征得您的授权同意：</strong></p>
          <p class="indent2">1.4.1 与国家安全、国防安全有关的；</p>
          <p class="indent2">1.4.2 与公共安全、公共卫生、重大公共利益有关的；</p>
          <p class="indent2">1.4.3 与犯罪侦查、起诉、审判和判决执行等有关的；</p>
          <p class="indent2">1.4.4 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
          <p class="indent2">1.4.5 所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
          <p class="indent2">1.4.6 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
          <p class="indent2">1.4.7 根据您要求签订和履行合同所必需的；</p>
          <p class="indent2">1.4.8 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
          <p class="indent2">1.4.9 法律法规规定的其他情形。</p>
          <p class="indent2">1.5 根据法律规定，向第三方提供经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
          <h5>第二章 如何使用您的个人信息</h5>
          <p class="indent2">在收集您的个人信息后，露禾平台将根据如下规则使用您的个人信息：</p>
          <p class="indent2">2.1 会根据本《隐私政策》的约定并为实现露禾平台的产品或服务功能对所收集的个人信息进行使用。</p>
          <p class="indent2">2.2 请您注意，对于您在使用露禾平台的产品或服务时所提供的所有个人信息，除非您删除或通过相关设置拒绝我们收集，否则您将在使用产品或服务期间、账号注销前持续授权我们使用。但在您注销账号时，露禾平台将停止使用并删除您的个人信息。</p>
          <p class="indent2">2.3 <strong>露禾平台会对产品或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息</strong>，以展示露禾平台产品或服务的整体使用趋势、及时修复产品在使用过程产生的故障及推送关于产品的最新咨询、功能。<strong>但这些统计信息不会包含您的任何身份识别信息。</strong></p>
          <p class="indent2">2.4 <strong>当露禾平台要将您的个人信息用于本政策未载明的其它用途时，或将基于特定目的收集而来的信息用于其他目的时，露禾平台会主动征求您的同意。</strong></p>
          <h5>第三章 如何共享、转让、公开披露您的个人信息</h5>
          <h5 class="indent2">共享</h5>
          <p><strong>3.1 露禾平台将严格遵守相关法律法规，对您的个人信息即账号信息、昵称信息、检索记录、浏览记录、下载记录、付费信息、订单信息、第三方支付信息（包含支付宝支付、微信支付）、手机号码、学科领域、用户身份、机构信息（下同），予以保密。除以下情况外，我们不会向其他人共享您的相关信息：</strong></p>
          <p class="indent2">3.1.1 事先获得您明确的同意或授权；</p>
          <p class="indent2">3.1.2 根据适用的法律法规规定，或基于司法或行政主管部门的强制性要求进行提供；</p>
          <p class="indent2">3.1.3 在法律法规允许的范围内，为维护您或其他露禾平台用户或其他个人的生命、财产等合法权益或是社会公共利益而有必要提供；</p>
          <p class="indent2">3.1.4 应您的监护人的合法要求而提供您的信息；</p>
          <p class="indent2">3.1.5 根据与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定而提供；</p>
          <h5 class="indent2">转让</h5>
          <p class="indent2">3.2 露禾平台不会将您的<strong>账号信息、昵称信息、检索记录、浏览记录、下载记录、付费信息、订单信息、第三方支付信息（包含支付宝支付、微信支付）、手机号码、学科领域、用户身份、机构信息（下同）</strong>转让给任何公司、组织和个人，但以下情况除外：</p>
          <p class="indent2">3.2.1 事先获得您明确的同意或授权；</p>
          <p class="indent2">3.2.2 根据适用的法律法规、法律程序的要求、强制性的行政或司法要求而必须进行提供；</p>
          <p class="indent2">3.2.3 根据与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定而提供；</p>
          <p class="indent2">3.2.4 在涉及收购、兼并、破产清算、重组等重大变更时，如涉及到个人信息转让的，露禾平台会要求新的持有您个人信息的公司或组织继续履行本《隐私政策》项下的责任和义务。如变更后的主体需变更个人信息使用目的，我们会要求其事先获得您的明示同意。</p>
          <h5 class="indent2">公开披露</h5>
          <p class="indent2">3.3 露禾平台仅会在以下情况下，且在采取符合业界标准的安全防护措施的前提下，才会公开披露您的<strong>账号信息、昵称信息、检索记录、浏览记录、下载记录、付费信息、订单信息、第三方支付信息（包含支付宝支付、微信支付）、手机号码、学科领域、用户身份、机构信息（下同）：</strong></p>
          <p class="indent2">3.3.1 根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</p>
          <p class="indent2">3.3.2 根据法律、法规的要求、行政或司法机关的强制性要求，我们可能会公开披露您的个人信息。当露禾平台收到上述披露请求时，露禾平台会依法要求请求方出具相关法律文件，如传票或协助调查函等。露禾平台会慎重审查每一个披露请求，以确保该等披露请求符合相关法律规定。在法律法规许可的前提下，露禾平台会对包含披露信息的文件采取加密保护等措施。</p>
          <h5>第四章 如何保护您的个人信息</h5>
          <p class="indent2">4.1 露禾平台非常重视个人信息安全，并会采取一切合理可行的措施，持续保护您的个人信息，以防其他人在未经授权的情况下访问、篡改或披露露禾平台收集的您的个人信息。</p>
          <p class="indent2">4.2 关于账号、手机号、密码传输过程的防篡改，<strong>我们全程对个人信息执行加密传输，用户密码保密输入，加密入数据库，手机号码隐藏中间四位。</strong></p>
          <p class="indent2">4.3 我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。</p>
          <p class="indent2">4.4 我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，<strong>我们会使用加密技术（例如，SSL/TLS）、匿名化处理等手段来保护你的个人信息。</strong></p>
          <p class="indent2">4.5 我们建立专门的管理制度、流程和组织以保障信息的安全。我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你设备本地完成部分信息加密的工作；<strong>为了预防诈骗、盗号、仿冒他人等不法行为和进行安全检查我们可能会分析利用唯一设备标识符、登录IP地址、操作日志、地理位置信息数据，以便于采取安全措施或对用户进行安全提醒。</strong></p>
          <p class="indent2">4.6 若发生个人信息泄露等安全事件，我们会依法启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知你安全事件的情况、事件可能对你的影响以及我们将采取的补救措施。我们还将按照法律法规和监管部门要求，上报个人信息安全事件的处置情况。</p>
          <p class="indent2">我们会尽力保护你的个人信息。我们也请你理解，任何安全措施都无法做到无懈可击。</p>
          <h5>第五章 如何保存您的个人信息</h5>
          <h5 class="indent2">保存期限</h5>
          <p class="indent2">5.1 在用户使用露禾平台产品或服务期间，露禾平台会持续保存用户的个人信息。</p>
          <p class="indent2">5.2 露禾平台承诺始终按照法律的规定在合理必要期限内在存储您个人信息，对于日志信息、记录备份等信息为您注销账号后180天（根据法律规定有最短保存期限要求的，则我们会保存法律要求的最短期限）；交易信息为交易完成日起三年或您注销账号后180天（以较长者为准）。<strong>在超出上述期限后，我们会对您的相关信息进行删除或匿名化处理。</strong></p>
          <h5 class="indent2">保存地域</h5>
          <p class="indent2"><strong>您的个人信息将全部被存储于中华人民共和国境内。</strong> </p>
          <p class="indent2">5.4 目前我们不存在向境外提供个人信息的场景。</p>
          <h5>第六章 关于cookies的使用</h5>
          <p class="indent2">6.1 在您未拒绝接受cookies的情况下，本应用会在您的计算机上设定或取用cookies ，以便您能登录或使用依赖于cookies的本应用平台服务或功能。本应用使用cookies可为您提供更加周到的个性化服务，包括推广服务。</p>
          <p class="indent2">6.2 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本应用网络服务或功能。</p>
          <p class="indent2">6.3 通过本应用所设cookies所取得的有关信息，将适用本政策。</p>
          <h5>第七章 管理、查看或删除您的个人信息</h5>
          <p class="indent2">露禾平台非常尊重您对自己的个人信息所享有的权利。我们保障您对个人信息所享有的访问、更正、删除、管理等权利。</p>
          <p class="indent2"><strong>访问和更正您的个人信息</strong></p>
          <p class="indent2">7.1 除法律法规另有规定之外，您有权行使数据访问权。当您发现我们处理关于您的个人信息有错误或者您有其他修改、补充需求时，您也有权要求我们或自行予以更正。您行使数据访问和更正权的方式包括但不限于：</p>
          <p class="indent2">7.1.1 如果您希望访问或修改您在露禾平台产品或服务中的账号信息，包括绑定机构、手机号、邮箱，您可以通过访问我们的产品进行操作（可通过点击“我的”，进入个人主页后，点击“设置”功能后进行操作）。 </p>
          <p class="indent2">7.2 您有权知悉通过露禾平台获得您的个人信息的第三方的身份或类型。您可以通过本政策第一章和第四章了解第三方的身份或类型。</p>
          <p class="indent2"><strong>删除您的个人信息及撤回已同意的授权</strong></p>
          <p class="indent2">7.3 在以下情形中，您可以向露禾平台提出删除个人信息的请求：</p>
          <p class="indent2">7.3.1 如果露禾平台处理个人信息的行为违反相关的法律法规；</p>
          <p class="indent2">7.3.2 如果露禾平台收集、使用您的个人信息，却未征得您的同意；</p>
          <p class="indent2">7.3.3 如果露禾平台处理个人信息的行为违反了与您的约定或法律的规定；</p>
          <p class="indent2">7.3.4 如果您不再使用露禾平台的产品或服务，或者您注销了相关账号；</p>
          <p class="indent2">7.3.5 如果露禾平台不再为您提供产品或服务。</p>
          <p class="indent2">7.4 您有权向露禾平台撤回您此前做出的有关同意收集、使用您的个人信息的授权。当您撤回同意后，我们将不再处理您的相关个人信息。但您撤回同意的决定，不会影响此前基于您的授权而开展的个人信息处理活动。</p>
          <p class="indent2">7.5 您可以通过删除相关个人信息的方式撤回您此前就特定个人信息而对我们做出的同意授权。</p>
          <h5 class="indent2">注销账号</h5>
          <p class="indent2">7.6 您有权随时注销您在露禾平台产品或服务中注册的账号，主要包含两种以下两种方式：</p>
          <p class="indent2">7.6.1 为保障账号及财产安全，您需要通过客户服务或本《隐私条款》第九章载明的联系方式向露禾平台提出您的账号注销请求。露禾平台将在与您核实相关信息后对您的请求做出响应。</p>
          <p class="indent2">7.6.2 您也可以<strong>通过露禾平台来手动注销账号信息（可通过点击“个人中心”，进入个人主页后，点击“注销账户”功能）</strong>，需要说明的是，注销页面会详细说明注销产生的影响和注销操作指引，<strong>账号注销后，您的账号将无法登录并将放弃以下权益和资产：</strong></p>
          <p class="indent2"><strong>①.文献浏览及下载记录将无法查询</strong></p>
          <p class="indent2"><strong>②.账号将会无法登录</strong></p>
          <p class="indent2"><strong>③.放弃平台更新提示服务及检索式订阅服务</strong></p>
          <p class="indent2"><strong>④.放弃优惠券和折扣权益</strong></p>
          <p class="indent2"><strong>⑤.放弃余额金额和会员权益</strong></p>
          <p class="indent2"><strong>⑥.账号信息将连同露禾APP一并注销</strong></p>
          <p class="indent2"><strong>请确保所有订单已完结并且无纠纷</strong></p>
          <p class="indent2">7.7 <strong>请您注意，注销露禾平台相关产品或服务账号是不可恢复的操作</strong>。在注销账号之后，我们将停止为您提供产品或服务，并将删除该账号项下的您的个人信息，除非法律法规另有规定。</p>
          <h5>第八章 本政策如何更新</h5>
          <p class="indent2">8.1 如露禾平台产品或服务发生以下变化，露禾平台将及时对本《隐私政策》进行相应的修订：</p>
          <p class="indent2">8.1.1 <strong>露禾平台产品或服务所涉业务功能发生变更，导致处理个人信息的目的、类型、使用方式发生变更；</strong></p>
          <p class="indent2">8.1.2 <strong>您参与个人信息处理方面的权利及其行使方式发生重大变化；</strong></p>
          <p class="indent2">8.1.3 露禾平台负责处理您的个人信息安全的部门的联络方式发生变更；</p>
          <p class="indent2">8.1.4 发生其他可能影响用户个人信息安全或影响用户隐私权利的变更等。</p>
          <p class="indent2">8.2《隐私政策》修订后露禾平台会在露禾平台产品或服务相关界面发布最新版本并以弹窗、推送通知等合理的方式告知用户，以便用户及时了解《隐私政策》的最新版本。</p>
          <p class="indent2">8.3 未经您的明确同意，露禾平台不会削减您基于本《隐私政策》所享有的权利。</p>
          <p class="indent2">8.4 如无特殊说明，修订后的《隐私政策》自公布之日起生效。</p>
          <h5>第九章 投诉及建议</h5>
          <p class="indent2">9.1 您在使用露禾平台产品或服务的过程中，如果对本《隐私政策》有任何的疑义或建议，或您认为个人信息没有得到本《隐私政策》规定的保护，您可以通过以下方式联系我们，我们将真诚地处理您的投诉及建议。</p>
          <p class="indent2">公司名称：重庆维普朗润数据科技有限公司</p>
          <p class="indent2">联系邮箱：viplangrun@langrundata.com</p>
          <p class="indent2">联系电话： 023-89690806（9:00-17:00）</p>
        </el-scrollbar>
      </div>
    </el-dialog>
    <!--S 入驻协议 -->
    <enter-protocol ref="enter-protocol"></enter-protocol>
    <!--E 入驻协议 -->
  </div>
</template>
<script>
import EnterProtocol from "@/components/Common/EnterProtocol";
export default {
  components: { EnterProtocol },
  data () {
    return {
      serveVisible: false,
      concealVisible: false,
      enterVisible: false
    }
  },
  methods: {
    showyins () {
      this.serveVisible = false
      this.concealVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/components/footer.scss";
</style>
